<template>
<CContainer>
    <CRow>
        <CCol col="12" class="d-flex overflow-auto px-0">
            <CreateBtn @click="createModalShow = true" v-if="$policy('conversion').create_any_or_group" class="mfe-2 mb-2" />
            <FilterIt class="mfe-2" />
            <SortIt class="mr-auto" />
        </CCol>
    </CRow>
    <Table :params="params"/>

    <CModal :show.sync="createModalShow" size="lg">
        <template #header-wrapper>
            <div></div>
        </template>

        <CreateForm ref="CreateForm" :submitForm="submitForm" :stores="stores" />

        <template #footer-wrapper>
            <div></div>
        </template>
    </CModal>
</CContainer>
</template>

<script>
import { mapActions } from 'vuex'
import { Table, FilterIt, SortIt, CreateForm } from './partials'
import { storeService, conversionService } from '@/services/api'
import { StoreStatus } from '@/constants'

export default {
    name: 'Conversions',

    components: {
        Table,
        FilterIt,
        SortIt,
        CreateForm,
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            if(vm.$policy('conversion').create_any_or_group) {
                vm.fetchStores()
            }
        })
    },

    beforeRouteUpdate(to, from, next) {
        next()

        if (to.name === 'conversions') {
            this.setParams(this.params)
            this.fetchConversions()
        }

    },

    data() {
        return {
            createModalShow: false,
            stores: []
        }
    },

    computed: {
        params() {
            return {
                store_id: this.$route.query.store_id,
                user_id: this.$route.query.user_id,
            }
        }
    },

    methods: {
        ...mapActions({
            fetchConversions: 'conversion/fetch',
            setParams: 'conversion/setParams',
        }),
        submitForm(data) {
            const createForm = this.$refs.CreateForm

            conversionService.createv2(data).then(res => {
                this.createModalShow = false
                this.fetchConversions()
            }).catch(error => {
                if(error.response) {
                    createForm.$refs.form.setErrors(error.response.data.data);
                }
            })
        },
        fetchStores() {
            storeService.fetch({
                status: StoreStatus.ACTIVE,
                no_paginate: true,
                just: ['id', 'name']
            }).then(res => res.data.data).then(result => this.stores = Object.keys(result).map((id) => {
                return {
                    value: result[id].id,
                    label: result[id].name,
                }
            }))
        }
    }
}
</script>
